import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { PreviewType } from '../block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('LoginBlock')
export class LoginBlock extends LeafBlock {
	@jsonProperty(Boolean)
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 1,
		label: 'Is Fullscreen',
		isBinding: false,
	})
	isFullscreen: boolean = true

	constructor(init: Partial<LoginBlock> = {}) {
		super()
		this.init(init)
	}

	producePreview(): PreviewType {
		return '<login />'
	}

	getEditorCategory(): string {
		return 'Others'
	}
}
